<template>
    <el-dialog
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            center
            custom-class="fix-dialog">
        <div ref="printbody">
            <el-row>
                <div class="main">
                    <div class="company">{{tenantname}}</div>
                    <div class="title"><u>{{formname}}</u></div>
                    <div>
                        <table cellspacing="0">
                            <tr>
                                <td>提交人：
                                </td>
                                <td>
                                    <div class="submit_person">
                                        {{uname}}{{"【"+dname+"】"}}
                                    </div>
                                </td>
                                <td>摘要：
                                </td>
                                <td colspan="3">
                                    <div id="summary">
                                        {{summary}}
                                    </div>
                                </td>

                            </tr>
                            <tr class="tr-borderbottom">
                                <td>提交日期：
                                </td>
                                <td>
                                    <div id="submit_date">
                                        {{adddate}}
                                    </div>
                                </td>
                                <td>合同：
                                </td>
                                <td colspan="3">
                                    <div id="agreement">{{hetongname}}</div>
                                </td>
                            </tr>
                            <tr class="tr-borderbottom">
                                <td>付款至：
                                </td>
                                <td>
                                    <div id="pay_for">
                                        {{customername}}
                                    </div>
                                </td>
                                <td><span id="span_HandleDate">办结日期：</span>
                                </td>
                                <td>
                                    <div id="pay_date">
                                        {{paydate}}
                                    </div>
                                </td>
                                <td>出纳：
                                </td>
                                <td>
                                    <div id="pay_cashier">
                                        {{payuname}}
                                    </div>
                                </td>
                            </tr>
                            <tr class="tr-borderbottom">
                                <td>应付金额：
                                </td>
                                <td>
                                    <div id="span_pay_money">
                                        {{paymoney}}
                                    </div>
                                </td>
                              <td>大写金额：
                              </td>
                              <td colspan="4">
                                <div id="big_money">
                                  {{bigpaymoney}}
                                </div>
                              </td>
                                <!--<td>核销金额：-->
                                <!--</td>-->
                                <!--<td>-->
                                    <!--<div id="span_pay_hexiao">-->
                                        <!--{{offsetcash}}-->
                                    <!--</div>-->
                                <!--</td>-->
                                <!--<td style="width: 50px" id="td_pay_bill"></td>-->
                                <!--<td>-->
                                    <!--<div id="span_pay_bill"></div>-->
                                <!--</td>-->
                            </tr>
                            <!--<tr class="tr-borderbottom">-->
                              <!---->

                            <!--</tr>-->
                            <tr class="tr-borderbottom">
                                <td colspan="3" style="border-right: 1px solid rgb(187,187,187);">
                                    <div class="content-fee">
                                        <ul>
                                            <li v-for="(ticket, index) in ticketlist"
                                                :index="ticket.unitguid"
                                                :key="ticket.unitguid">
                                                <span class='fee-type'>{{ticket.categoryname}}</span>
                                                <span class='fee-money'>{{ticket.submoney}}</span>
                                                <span class='fee-nums'>{{ticket.ticketsnums}}张</span>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                                <td colspan="3">
                                    <div class="content-flow">
                                        <ul>
                                            <li v-for="(todo, index) in todolist"
                                                :index="todo.unitguid"
                                                :key="todo.unitguid">
                                                {{todo.opuname==null?todo.targetuname:(todo.opuname==todo.targetuname?todo.opuname:(todo.opuname+"【"+todo.targetuname+"】"))}}:{{todo.op}} {{todo.hddate}}
                                            </li>
                                        </ul>
                                    </div>
                                </td>

                            </tr>
                            <tr class="tr-borderbottom">

                                <td colspan="6" style="text-align: left">
                                    <span style="margin-left: 40px;">备注：</span>
                                    {{remark}}
                                </td>

                            </tr>

                        </table>
                    </div>

                </div>
            </el-row>
        </div>

        <div
                slot="footer"
                class="dialog-footer"
        >

            <el-button type="info" @click="printPay">打印</el-button>
            <el-button @click="dialogFormVisible = false">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {convertToBigMoney, ConvertMoney} from "@/plugin/ordercommon";

    export default {
        name: "payprint",
        data() {
            return {
                dialogFormVisible: false,
                tenantname: "",
                uname: "",
                dname: "",
                summary: "",
                adddate: "",
                hetongname: "",
                customername: "",
                paydate: "",
                payuname: "",
                paymoney: "",
                offsetcash: "",
                formname: "",
                bigpaymoney: "",
                remark: "",
                ticketlist: [],
                todolist: [],
            }
        },
        methods: {
            show: function (formdata, ticketlist, todolist) {
                var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
                this.tenantname = userinfo.tenantname;
                this.dialogFormVisible = true;
                this.ticketlist = [].concat(ticketlist);
                this.todolist = todolist;
                for (var form in formdata) {
                    this[form] = formdata[form];
                }
                var ticketHeJi = {categoryname: "合计", submoney: 0, ticketsnums: 0};
                ticketlist.forEach(ticket => {
                    ticketHeJi.submoney += parseFloat(ticket.submoney);
                    ticketHeJi.ticketsnums += parseFloat(ticket.ticketsnums);
                    ticket.submoney = ConvertMoney(ticket.submoney, 2);
                });
                ticketHeJi.submoney = ConvertMoney(ticketHeJi.submoney, 2);
                if (!formdata.customername) {
                    //报销单，付钱给申请人
                    this.customername = formdata["uname"];
                }
                this.ticketlist.push(ticketHeJi);
                this.paydate = formdata["paydate"] ? formdata["paydate"].substr(0, 10) : "";
                this.bigpaymoney = convertToBigMoney(formdata["paymoney"]);
                this.paymoney = "￥" + ConvertMoney(formdata["paymoney"], 2);
                this.offsetcash = ConvertMoney(formdata["offsetcash"], 2);
            },
            printPay: function () {
                this.$print(this.$refs.printbody)
            }
        }
    }
</script>

<style scoped>
    body {
        font-size: 14px;
        font-family: 微软雅黑;
    }

    /*打印按钮*/
    .head {
        width: 100%;
        height: 40px;
        margin: 0 auto;
        text-align: center;
    }

    .main {
        width: 1000px;
        margin: 0 auto;
        text-align: center;
        margin: 0 auto;
    }

    .company {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        height: 30px;
        width: 1000px;
    }

    .title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        height: 30px;
        width: 1000px;
    }

    table {
        margin: 15px auto 0 auto;
        width: 1000px;
        border-collapse: collapse;
        border: 2px solid rgb(42, 42, 42);
    }

    table td {
        width: 45px;
        text-align: right;
        line-height: 30px;
    }

    table td div {
        text-align: left;
    }

    .tr-borderbottom {
        border-bottom: 2px solid rgb(42, 42, 42);
    }

    #remark {
        width: 90%;
        height: 30px;
        border: none;
    }

    #span_pay_money, #span_pay_hexiao, #span_pay_bill {
        font-weight: bold;
    }

    .content-fee {
        width: 700px;
        height: 150px;
        min-height: 150px;
        display: table-cell;
    }

    .content-fee ul li {
        height: 30px;
        line-height: 30px;
        border-bottom: 1px dashed rgb(187, 187, 187);
    }

    .content-fee ul li.fee-total {
        height: 30px;
        line-height: 30px;
        border-bottom: none;
    }

    .content-fee ul li span {
        display: inline-block;
    }

    .content-flow {
        min-height: 150px;
        padding: 5px 0 0 10px;
    }

    .fee-money, .fee-nums {
        text-align: right;
        width: 25%;
    }

    .fee-type {
        padding-left: 5px;
        width: 40%;
    }


</style>



// WEBPACK FOOTER //
// src/components/oa/payform/PayPrint.vue